import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { SKILLSVIEW_LOGO_SRC } from "@/assets/brandImages";
import { Bell, LogOut, RefreshCw, User } from "lucide-react";

const LogoMark = ({ className = "" }) => (
  <img src={SKILLSVIEW_LOGO_SRC} alt="SkillsView" className={`h-9 w-auto object-contain ${className}`} />
);

const AdminHeader = ({
  activeTab,
  setActiveTab,
  setFocusedStatus,
  unreadNotifications,
  fetchData,
  handleLogout,
}) => (
  <header className="fixed top-0 left-0 right-0 z-50 bg-black/70 backdrop-blur-xl border-b border-white/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-3">
          <LogoMark className="max-w-[160px]" />
          <Badge className="bg-[#CCFF00]/20 text-[#CCFF00]">Admin</Badge>
        </Link>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => { setActiveTab("notifications"); setFocusedStatus(null); }}
            className={`relative p-2 ${activeTab === "notifications" ? "text-[#CCFF00]" : "text-zinc-400 hover:text-white"}`}
            title="Notifications"
          >
            <Bell className="w-5 h-5" />
            {unreadNotifications > 0 && (
              <span className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-[#CCFF00] px-1 text-xs font-black text-black">
                {unreadNotifications}
              </span>
            )}
          </button>

          <button
            type="button"
            onClick={() => { setActiveTab("profile"); setFocusedStatus(null); }}
            className={`hidden sm:flex items-center gap-2 px-3 py-2 text-sm font-bold uppercase ${activeTab === "profile" ? "text-[#CCFF00]" : "text-zinc-400 hover:text-white"}`}
          >
            <User className="w-4 h-4" />
            Profil
          </button>

          <button onClick={fetchData} className="p-2 text-zinc-400 hover:text-white" title="Rafraîchir">
            <RefreshCw className="w-5 h-5" />
          </button>

          <button onClick={handleLogout} className="flex items-center gap-2 text-zinc-400 hover:text-white">
            <LogOut className="w-5 h-5" />
            <span className="hidden sm:block text-sm">Déconnexion</span>
          </button>
        </div>
      </div>
    </div>
  </header>
);

export default AdminHeader;
